import Select from './index'

export default {
  name:'Post',
  props:['companyId' , 'type', 'value'],
  created(){
    this.$watch('companyId' , function(nv){

    },{immediate:true})
  },
  computed:{
    values(){
      let {companyId ,  type} = this
      if(companyId){
        return this.$request.common_post_extra({companyId , type}).then(resp => {
          return Promise.resolve( (resp.data || []).map( i => ({value:i.id , label:i.name})) )
        })
      }else{
        return []
      }
    }
  },
  methods:{
    onChange(v){
      this.$emit('change' , v)
      this.$emit('input' , v)
    }
  },
  render(){
    return <Select dict={this.values} filterable value={this.value} on-change={this.onChange} />
  }
}